import {
  ButtonLoginContainer,
  ContentSection,
  HeroExplainer,
  HeroHeader,
  HowItWorksExplainer,
  HowItWorksImage,
  HowItWorksImageWrappers,
  HowItWorksMovieImage,
  HowItWorksText,
  JoinFreeTrialButton,
  JoinHeroImg,
  JoinLogo,
  JoinNav,
  JoinNavContent,
  JoinNavLink,
  JoinPageWrapper,
  LinkContainer,
  LoginJoinNav,
  ProviderSVG,
  RefPoint,
  RowImage,
  RowWrapper,
  SecondaryHeader,
  SecondarySection,
  SignUp,
  UpperLinkContainer,
} from "./JoinClearplay.styles";
import providers from "../assets/images/providers.svg";
import filtering from "../assets/images/filtering-image.svg";
import amazon from "../assets/images/amazon-row.webp";
import apple from "../assets/images/apple-row.webp";
import max from "../assets/images/max-row.webp";
import netflix from "../assets/images/netflix-row.webp";
import disney from "../assets/images/disney-row.webp";
import movieImg from "../assets/images/captain-america.png";
import { useHistory } from "react-router-dom";
import { AppRoutes } from "../app/routes";
import Footer from "../features/components/Footer";
import ClearPlayLogo from "../assets/images/clearplay.svg";
import { useRef } from "react";
import { Helmet } from "react-helmet";
import { useCookies } from "react-cookie";

const JoinClearplay: React.FC = () => {
  const history = useHistory();
  const howItWorksRef = useRef<HTMLDivElement>(null);
  const [hasLoggedIn, setHasLoggedIn] = useCookies(['cp_isLoggedIn']);

  const scrollToHowItWorks = () => {
    howItWorksRef.current?.scrollIntoView({ behavior: "smooth" });
  };


  return (
    <JoinPageWrapper>
      <Helmet>
        <title>
          Clearplay - Family-Friendly Movie and TV Show Filtering for Amazon,
          Apple TV+, Disney Plus, Max, Netflix, and More
        </title>
        <meta
          name="description"
          content="Clearplay offers family-friendly filtering options for movies and TV shows. Skip and mute unwanted scenes and language with our web-based filtering solution. Compatible with popular streaming services like Amazon, Apple TV+, Disney Plus, Netflix, HBO Max, and more."
        />
        <meta
          name="keywords"
          content="Family-friendly filtering, Family movies, Movie and TV show filtering, Content filtering for kids and families, Filtering options for movies and TV shows, Skip and mute unwanted scenes and language, Web-based filtering solution, Compatible with streaming services like Amazon, Apple TV+, Disney Plus, Netflix, HBO Max"
        />
      </Helmet>
      <JoinNav>
        <JoinNavContent>
          <JoinLogo
            onClick={() => history.push(AppRoutes.HOME)}
            src={ClearPlayLogo}
          />
          <UpperLinkContainer>
            <JoinNavLink
              onClick={() =>
                window.open("https://try.clearplay.com/licensing-agreement/")
              }
            >
              License Agreement
            </JoinNavLink>
            <JoinNavLink
              onClick={() =>
                window.open("https://try.clearplay.com/disclaimer/")
              }
            >
              Disclaimer
            </JoinNavLink>
            <JoinNavLink onClick={scrollToHowItWorks}>How it works</JoinNavLink>
          </UpperLinkContainer>
          <ButtonLoginContainer>
           { <JoinFreeTrialButton
              onClick={() =>
                history.push(`${AppRoutes.SIGNUP_EMAIL}?utm_source=homepage`)
              }
            >
             {!hasLoggedIn.cp_isLoggedIn ? 'Free Trial' : 'Sign Up'}
            </JoinFreeTrialButton>}
            <LoginJoinNav onClick={() => history.push(AppRoutes.ENTER_EMAIL)}>
              Log in
            </LoginJoinNav>
          </ButtonLoginContainer>
        </JoinNavContent>
        <LinkContainer>
          <JoinNavLink
            onClick={() =>
              window.open("https://try.clearplay.com/licensing-agreement/")
            }
          >
            License Agreement
          </JoinNavLink>
          <JoinNavLink
            onClick={() => window.open("https://try.clearplay.com/disclaimer/")}
          >
            Disclaimer
          </JoinNavLink>
          <JoinNavLink onClick={scrollToHowItWorks}>How it works</JoinNavLink>
        </LinkContainer>
      </JoinNav>
      <JoinHeroImg>
        <HeroHeader>
          Enjoy family-friendly versions of the TV shows and movies you stream!
        </HeroHeader>
        <ProviderSVG src={providers} alt="providers" />
        <HeroExplainer>
          {" "}
          Seamlessly skip scenes with language or graphic content you don't want
          to see based on your selections.
        </HeroExplainer>
       {<SignUp
          onClick={() =>
            history.push(`${AppRoutes.SIGNUP_EMAIL}?utm_source=homepage`)
          }
        >
          {!hasLoggedIn.cp_isLoggedIn ? 'Start Your 30-Day Free Trial' : 'Sign Up'}
        </SignUp>}
      </JoinHeroImg>
      <RefPoint ref={howItWorksRef} />
      <ContentSection>
        <HowItWorksExplainer>
          <HeroHeader>How it works</HeroHeader>
          <HowItWorksText>
            Filter thousands of movies and TV shows from your favorite streaming
            services.
          </HowItWorksText>
          <HowItWorksText>
            Filtering options put you in control of categories such as violence
            and sub-categories such as gory/brutal violence.
          </HowItWorksText>
        </HowItWorksExplainer>
        <HowItWorksImageWrappers>
          <HowItWorksMovieImage src={movieImg} alt="movie image" />
          <HowItWorksImage src={filtering} alt="filtering" />
        </HowItWorksImageWrappers>
      </ContentSection>
      <SecondarySection>
        <SecondaryHeader>Start Watching Now</SecondaryHeader>
        <RowWrapper>
          <SecondaryHeader>Amazon</SecondaryHeader>
          <RowImage src={amazon} alt="row" />
        </RowWrapper>
        <RowWrapper>
          <SecondaryHeader>Apple TV+</SecondaryHeader>
          <RowImage src={apple} alt="row" />
        </RowWrapper>
        <RowWrapper>
          <SecondaryHeader>Disney+</SecondaryHeader>
          <RowImage src={disney} alt="row" />
        </RowWrapper>
        <RowWrapper>
          <SecondaryHeader>Max</SecondaryHeader>
          <RowImage src={max} alt="row" />
        </RowWrapper>
        <RowWrapper>
          <SecondaryHeader>Netflix</SecondaryHeader>
          <RowImage src={netflix} alt="row" />
        </RowWrapper>
      </SecondarySection>
      <SecondarySection>
        <HeroHeader>Start Filtering with a Free Trial</HeroHeader>
        <HeroExplainer>
          Choose between monthly and annual subscription plans.
        </HeroExplainer>
        <SignUp
          onClick={() =>
            history.push(`${AppRoutes.SIGNUP_EMAIL}?utm_source=homepage`)
          }
        >
          Start Your 30-Day Free Trial
        </SignUp>
        <HeroExplainer>Watch anytime, just $7.99/month.</HeroExplainer>
      </SecondarySection>
      <Footer />
    </JoinPageWrapper>
  );
};

export default JoinClearplay;
